import React from 'react';
import { IStyleProps, LottieAnimation } from '../LottieAnimation';
import pot from './pot.json';

export const LottiePot: React.FC<IStyleProps> = (props) => <LottieAnimation animationData={pot} {...props} />;
